module.exports = __webpack_public_path__ + "img/footer.79781d73.webp";